class SizeGuideSidebar extends HTMLElement {
  constructor() {
    super();
    this._onKeydown = this._onKeydown.bind(this);
  }

  connectedCallback() {
    this._panel = this.querySelector('.size-guide-sidebar__panel');
    this._drawer = this.querySelector('.size-guide-sidebar__drawer');
    this._trigger = this.querySelector('.size-guide-sidebar__trigger');
    this._closeBtn = this.querySelector('.size-guide-sidebar__close');
    this._overlay = this.querySelector('.size-guide-sidebar__overlay');

    // Move panel to <body> so it escapes any ancestor stacking context /
    // transform that would otherwise clip it behind the sticky header.
    if (this._panel && this._panel.parentNode !== document.body) {
      document.body.appendChild(this._panel);
    }

    this._trigger.addEventListener('click', () => this.open());
    this._closeBtn.addEventListener('click', () => this.close());
    this._overlay.addEventListener('click', () => this.close());
  }

  disconnectedCallback() {
    if (this._panel && this._panel.parentNode === document.body) {
      this._panel.remove();
    }
    document.removeEventListener('keydown', this._onKeydown);
    document.body.style.overflow = '';
  }

  open() {
    this._panel.removeAttribute('hidden');
    // Force reflow so the CSS transition fires
    this._panel.getBoundingClientRect();
    this._panel.classList.add('is-open');
    this._trigger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', this._onKeydown);
    this._panel.focus();
  }

  close() {
    this._panel.classList.remove('is-open');
    this._trigger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', this._onKeydown);

    // Hide after transition completes
    this._drawer.addEventListener(
      'transitionend',
      () => this._panel.setAttribute('hidden', ''),
      { once: true }
    );

    this._trigger.focus();
  }

  _onKeydown(event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      this.close();
    }

    if (event.key === 'Tab') {
      this._trapFocus(event);
    }
  }

  _trapFocus(event) {
    const focusable = Array.from(
      this._drawer.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      )
    ).filter((el) => !el.disabled && el.offsetParent !== null);

    if (focusable.length === 0) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey) {
      if (document.activeElement === first) {
        event.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }
}

customElements.define('size-guide-sidebar', SizeGuideSidebar);
